import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { isRequestActive } from "redux-request-loading";
import { Loader, Modal } from "semantic-ui-react";

import { MedicalType } from "@teamprevent/common/healthSurveillance/models";

import { loadTaskTypes } from "../actions";
import { createTasks } from "../../crud/ohCase/actions";
import { CREATE_OHCASE_TASKS } from "../../crud/ohCase/actiontypes";
import { PartialOhCaseDetailModel } from "../../crud/ohCase";
import { CreateTaskModel } from "../../task/model";
import { ApplicationState } from "../../applicationState";
import { loadImmunisationTypes } from "../../crud/immunisationType";
import { loadImmunisationTypeTasks } from "../../crud/immunisationTypeTask";
import { selectors as customerSelectors } from "../../crud/customer";
import { selectors as immunisationTypeSelectors } from "../../crud/immunisationType";
import { TasksTypesSelector } from "../../task/selectors";

import { AddTasksForm } from "./addTasksForm";

interface OwnProps {
    ohCase: PartialOhCaseDetailModel;
    customerId: string;
    open: boolean;
    onClose: () => void;
    medicalTypes?: MedicalType[];
    caseType?: string;
    assignmentOptionRequired?: boolean;
}

const immunisationTypeTasksSelector = (state: ApplicationState) => state.immunisationTypeTasks;
const isCreatingTaskSelector = (state: ApplicationState) => isRequestActive(state, CREATE_OHCASE_TASKS);

export const AddMultipleTasksModalOld: React.FunctionComponent<OwnProps> = ({ ohCase, onClose, ...props }) => {
    const customerId = useSelector(customerSelectors.routeIdSelector);
    const immunisationTypeTasks = useSelector(immunisationTypeTasksSelector);
    const taskTypes = useSelector(TasksTypesSelector);
    const immunisationTypes = useSelector(immunisationTypeSelectors.immunisationTypesSelector);
    const isCreatingTask = useSelector(isCreatingTaskSelector);
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (ohCase.immunisations) {
            dispatch(loadImmunisationTypes());
            ohCase.immunisations.forEach(immunisationType => dispatch(loadImmunisationTypeTasks({ immunisationTypeId: immunisationType.typeId })));
        }
    }, [dispatch, ohCase.immunisations]);

    React.useEffect(() => {
        if (customerId && ohCase?.id) {
            dispatch(loadTaskTypes(customerId, ohCase?.id));
        }
    }, [customerId, dispatch, ohCase?.id]);

    const onSubmit = React.useCallback(async (tasks: CreateTaskModel[]) => {
        await dispatch(createTasks(customerId, ohCase.id, tasks));
        onClose();
    }, [customerId, dispatch, ohCase.id, onClose]);

    if (!taskTypes) {
        return <Loader active />;
    }

    return (
        <Modal open={props.open}>
            <Modal.Header>
                Add Tasks
            </Modal.Header>
            <Modal.Content>
                <AddTasksForm
                    onSubmit={onSubmit}
                    taskTypes={taskTypes}
                    immunisationTypes={immunisationTypes}
                    immunisationTypeTasks={immunisationTypeTasks}
                    creatingTask={isCreatingTask}
                    onCancel={onClose}
                    ohCaseId={ohCase.id}
                    ohCase={ohCase}
                    medicalTypes={props.medicalTypes}
                    caseType={props.caseType}
                    assignmentOptionRequired={props.assignmentOptionRequired}
                />
            </Modal.Content>
        </Modal>
    );
};
